import JourneySegmentContainer from './JourneySegmentContainer';

export default JourneySegmentContainer;
